module.exports = __webpack_public_path__ + "media/webfonts/fa-brands-400-89a52ae1.eot";